import CF from "./common-functions";
import cars from "./cars-info";
import finances from "@/common/finance";
import DateRefresher from "date-refresher";

const finance = finances.filters.finance;

const MAX_BENEFIT = finance(Math.max.apply(null, cars.map((car) => car.benefit.replaceAll(' ', ''))));

const MIN_PAYMENT = Math.min.apply(null, cars.map((car) => car.permonth));

const PHONE = "+7 (495) 126-30-05";
const PHONE_RAW = PHONE.replace(/(?!^\+)\D+/g, "");

const DAY = 86400000;
const interval = DAY * 3;
const today = new Date();
let start_date = new Date(2023, 2, 6);
let end_date = new Date(2023, 2, 12);

while (today.valueOf() - interval >= start_date) {
  start_date = new Date(start_date.valueOf() + interval);
  end_date = new Date(end_date.valueOf() + interval);
}

const start = `${
  start_date.getDate() < 9 ? "0" + start_date.getDate() : start_date.getDate()
}.${
  start_date.getMonth() + 1 < 9
    ? "0" + (start_date.getMonth() + 1)
    : start_date.getMonth() + 1
}.${start_date.getFullYear()}`;

const end = `${
  end_date.getDate() < 9 ? "0" + end_date.getDate() : end_date.getDate()
}.${
  end_date.getMonth() + 1 < 9
    ? "0" + (end_date.getMonth() + 1)
    : end_date.getMonth() + 1
}.${end_date.getFullYear()}`;

export default {
  address: "г. Москва, Иркутская улица, 5/6с1",
  phone: PHONE,
  phone_raw: PHONE_RAW,
  max_benefit: MAX_BENEFIT,
  min_payment: MIN_PAYMENT,
  worktimes: ["Ежедневно с 9:00 до 21:00", "С 9:00 до 21:00"],
  coords: {
    x_center_big: 37.784291,
    x_center_small: 37.784291,
    y_center: 55.816197,
    x_salon: 37.784291,
    y_salon: 55.816197,
  },
  period: {
    start,
    end,
  },
  salon_name: "JAECOO Автомир",
  teh_name: "JAECOO Автомир",
  need_agreement: true,
  cKeeper: "ctw",
};

export const TIMER = {
  date: '02.03.2026',
  days: 3,
  time: '00:00'
};

export const endDate = DateRefresher.updateByInterval(TIMER.date, TIMER.days, TIMER.time);


